export const ALLERGENS = [
	"gluten",
	"crustaceans",
	"eggs",
	"fish",
	"peanuts",
	"soybeans",
	"milk",
	"nuts",
	"celery",
	"mustard",
	"sesame",
	"sulphur",
	"lupin",
	"molluscs",
] as const
